import { cardStrategy } from "./card.strategy";
import { sberpayStrategy } from "./sberpay.strategy";
import { cardLoginStrategy } from "./cardLogin.strategy";
import { emailStrategy } from "./email.strategy";
export var strategies = [cardStrategy, sberpayStrategy, cardLoginStrategy, emailStrategy];